<template>
    <div class="drawer">
        <!--<div class="drawer-type mt-2">OVERALL PROGRESS</div>-->
            <!--<div class="drawer-contents">-->
                <!--<div class="problem-card">All Assignments</div>-->
            <!--</div>-->
        <div class="drawer-type">
            <div v-if="!practice" class="drawer-title left">{{ lang['general.progress'] }}</div>
            <div v-if="practice"  class="drawer-title left">{{ lang['stats.practice_label'] }}</div>
        </div> <!-- {{ lang['general.assignments'] }} -->

            <div class="mt-4 flex-r flex-center" style="font-size: 1.25em;" v-if="drawerLoading">
                <div><i class="far fa-spinner fa-spin mr-2 blue"></i> {{ lang['general.loading'] }}</div>
            </div>

            <div v-if="!drawerLoading" class="drawer-contents">
                <template v-if="!practice">
                    <div id="card0" class="problem-card selected" @click="viewStats(null, 0)">
                        <!--<div class="prefix mr-1">{{ index + 1 }}. </div>-->
                        <div class="problem-text">{{ lang['general.overall_progress'] }}</div>
                        <div class="flex-r">
                            <div class="flex-c flex-center"><i class="fal fa-spinner fa-spin stats-spinner hidden"></i></div>
                            <i class="fal fa-chart-bar stats-icon ml-2 main-blue"></i></div>
                    </div>
                    <div v-for="(assignment, index) in assignments" class="problem-card" :id="cardID(index + 1)" @click="viewStats(assignment, index + 1)">
                        <!--<div class="prefix mr-1">{{ index + 1 }}. </div>-->
                        <div class="problem-text" v-html="$options.filters.stripAndTruncate(assignment.name, 30, '')">Assignment</div>
                        <div v-if="assignment.started" class="flex-r">
                            <div class="flex-c flex-center"><i class="fal fa-spinner fa-spin stats-spinner hidden"></i></div>
                            <div class="ml-2">{{ assignment.summary }}</div>
                            <div class="flex-c flex-center ml-2"><i class="fal fa-chart-bar stats-icon"></i></div>
                        </div>
                        <div v-if="!assignment.started" class="flex-r flex-stiff">
                            <div class="flex-c flex-center subtitle">{{ assignment.summary }}</div>
                        </div>
                    </div>
                </template>
                <template v-if="practice">
                    <div v-for="(problem, index) in problems" class="problem-card" :class="setActive(index)" @click="openProblem(problem, index + 1, 7)">
                        <div class="prefix mr-1">{{ index + 1 }}. </div>
                        <div class="problem-text" v-html="$options.filters.stripAndTruncate(problem.question, 32, '')">PROBLEM</div>
                        <div class="problem-markers">
                            <i class="fas fa-bookmark mr-3" :class="{ flagged: problem.flagged }"></i>
                            <i class="fa-square" :class="[problem.complete ? 'fas' : 'far']"></i>
                        </div>
                    </div>
                </template>
            </div>

            <div v-if="!drawerLoading" class="button-footer">
                <button type="button" v-if="practice" class="btn btn-primary btn-block" @click="endPractice">{{ lang['stats.practice_end_button'] }}</button>
                <button type="button" v-if="!practice" class="btn btn-primary btn-block" @click="clearStats">{{ lang['stats.clear_stats_button'] }}</button>
            </div>

        <stats-modal v-if="showModal == 'stats'" :statsData="modalData" @close="closeModal"></stats-modal>
        <problem-modal v-if="showModal == 'feedback'" :type="feedbackType" :decisionIndex="feedbackDecisionIndex" :decisionId="feedbackDecisionID" :message="debugMessage" @close="closeModal" @submit="closeModal"></problem-modal>

    </div>
</template>

<script>
export default {
    name: "assignments_progress",
    props: ['course',
            'model'],
    data() {
        return {
            assignments: [],
            drawerLoading: true,
            modalData: [],
            feedbackType: '',
            feedbackDecisionID: 0,
            feedbackDecisionIndex: 0,
            showModal: '',
            selectedIndex: 0,
            lang: lang,
            problems: [],
            practice: false,
            debugMessage: '',
        }
    },

    mounted() {
        let vue = this;
        $.get('/models/' + this.model + '/assignments/' + this.course + '/' + userData.id,
            response => {
                response.assignments.forEach(assignment => {
                    vue.assignments.push(assignment);
                });
                let a = 0;
                vue.drawerLoading = false;
            });
        bus.$on('openModal', this.openModal);
        bus.$on('beginPractice', this.beginPractice);
        bus.$on('traverseProblems', this.traverseProblems);
        bus.$on('showIncorrect', this.showFeedback);
        bus.$on('showFeedback', this.showFeedback);
        bus.$on('markComplete', this.markComplete);
    },

    methods: {
        openModal(modalType, data) {
            this.modalData = data;
            this.showModal = modalType;
        },

        showFeedback(type, nID = 0, index = 0) {
            this.feedbackType = type;
            this.feedbackDecisionIndex = index;
            this.feedbackDecisionID = nID;
            this.showModal = 'feedback';
        },

        markComplete(id, complete) {
            this.problems.forEach(problem => {
                if(problem.id == id) {
                    problem.complete = complete;
                }
            });
            this.$forceUpdate(); //fixes bug where list wasn't updating properly
            if(feedbackLevel != 0) {
                this.showFeedback('complete');
            }
        },

        closeModal() {
            this.modalData = {};
            this.showModal = '';
        },

        cardID(index) {
            return "card" + index;
        },

        beginPractice(nID){
            this.practice = true;
            this.selectedIndex = 1;
            switchToMode("path");
            buildPracticeAssignmentObj(nID);
            this.problems = assignmentObj.questions;
            this.openProblem(this.problems[0], 1);
        },

        showIncorrect(messageType){
            bus.$emit('showIncorrect', messageType);
        },

        endPractice(){
            window.location.reload();
        },

        setActive(index) {
            return this.selectedIndex == index + 1 ? 'selected' : '';
        },

        openProblem(problem) {
            if(currentPath.length > 0) {
                saveProblemProgress()
            }
            currentQID = problem.qID;
            this.selectedIndex = problem.index;
            this.$nextTick(function() {
                bus.$emit('viewProblem', problem);
            });
            showProblem();
        },

        traverseProblems(direction) {
            if(direction == 1 && (this.selectedIndex < this.problems.length)) {
                const nextProblem = this.problems[this.selectedIndex];
                this.selectedIndex = ++this.selectedIndex;
                this.openProblem(nextProblem);
            } else if(direction == -1 && this.selectedIndex !=1) {
                const nextProblem = this.problems[this.selectedIndex - 2];
                this.selectedIndex = --this.selectedIndex;
                this.openProblem(nextProblem);
            }
        },

        clearStats() {
            $(".nodeRect").attr("style", null);
            $(".link").attr("style", null);
            $(".stats-icon.main-blue").removeClass("main-blue");
            $("#detailsButtons").empty();
            $(".problem-card").removeClass("selected");
            clearStatsData();
        },

        viewStats(assignment, index) {
            $(".nodeRect").attr("style", null);
            $(".link").attr("style", null);
            $(".stats-icon.main-blue").removeClass("main-blue");
            $("#detailsButtons").empty();
            if($("#card"+index).hasClass("selected")){
                $("#card"+index).removeClass("selected");
                clearStatsData();
                return;
            }
            $(".problem-card").removeClass("selected");
            $("#card"+index).addClass("selected");
            $("#card"+index+" .stats-icon").addClass("main-blue");
            $("#card"+index+" .stats-spinner").removeClass("hidden");
            if(index == 0){
                loadStudentStats(); //userData.id, this.course);
            }
            else {
                loadStudentAssignmentStats(userData.id, dbCourse.course_id, assignment.id);
            }
        },
    }
}
</script>

<style scoped>

</style>
